import BaseTelephoneInput from "react-phone-input-2";
import styled from "styled-components";
import color from "../_style/color";

const TelephoneInput = styled(BaseTelephoneInput)`
  width: 100%;
  border: none;
  outline: 0 !important;

  .selected-flag {
    height: 35px;
    border: 1px solid ${color.gainsboro};
    outline: 0;
  }

  > .react-tel-input.country-list {
    list-style: none;
    position: absolute !important;
    z-index: 500 !important;
    padding: 0;
    margin: -1px 0 0 -1px;
    background-color: ${color.light};
    width: 310px;
    max-height: 200px;
    overflow-y: scroll;
    border-radius: 0 0 3px 3px;
    top: 34px;
  }

  input[type="tel"] {
    outline: 0;
    line-height: 35px;
    height: 35px;
    font-weight: 300;
    width: 100%;
    border: none;
    font-size: 20px;
    position: relative;
    border-bottom: 1px solid ${color.gainsboro};
    box-shadow: none;
    border-radius: 0;
  }

  input[type="tel"]:focus,
  input[type="text"]:focus {
    border-color: ${color.primary};
  }
`;

export default TelephoneInput;
